import React, { memo } from 'react'
import { IconButton } from '@mui/material'
import { faCircleQuestion } from '@fortawesome/pro-light-svg-icons'

import FaIcon from '../FaIcon/FaIcon'
import CustomTooltip from '../CustomTooltip/CustomTooltip'

const PopoverHelpText = ({ label }) => {
  return (
    <CustomTooltip label={label}>
      <IconButton sx={{ pt: 0.5, pb: 0.5, fontSize: 'inherit' }} disableRipple>
        <FaIcon width={16} icon={faCircleQuestion} />
      </IconButton>
    </CustomTooltip>
  )
}

export default memo(PopoverHelpText)
